import { TextareaHTMLAttributes } from 'react';
import { StyledTextArea } from './TextArea.styles';

type SpecificTextAreaProps = Pick<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  | 'id'
  | 'maxLength'
  | 'name'
  | 'onChange'
  | 'onKeyDown'
  | 'placeholder'
  | 'onBlur'
  | 'onFocus'
  | 'rows'
  | 'autoFocus'
  | 'value'
>;

type TextAreaProps = SpecificTextAreaProps & {
  height?: string;
  maxWidth?: string;
  padding?: string;
  resize?: 'both' | 'horizontal' | 'vertical' | 'none';
  isDisabled?: boolean;
  inputRef?: React.Ref<HTMLTextAreaElement>;
  fontSize?: string;
};

const TextArea = ({
  height,
  id,
  inputRef,
  maxLength,
  maxWidth,
  name,
  onChange,
  onKeyDown,
  padding,
  placeholder,
  value,
  onBlur,
  onFocus,
  rows,
  autoFocus = true,
  resize = 'none',
  isDisabled,
  fontSize = '12px',
}: TextAreaProps) => (
  <StyledTextArea
    autoFocus={autoFocus}
    id={id ? id : name}
    height={height}
    maxLength={maxLength}
    maxWidth={maxWidth}
    name={name}
    onChange={onChange}
    onKeyDown={onKeyDown}
    padding={padding}
    ref={inputRef}
    placeholder={placeholder}
    value={value}
    onBlur={onBlur}
    onFocus={onFocus}
    resize={resize}
    rows={rows}
    disabled={isDisabled}
    fontSize={fontSize}
  />
);

export default TextArea;
